import { appUrls } from "@/constants";

/**
 * The image-video deep-link contract shared by the creative-template pages and the Interactive
 * Image demo: prefill the app's image-video tool with a model + prompt (+ optional input/source
 * asset) so the visitor resumes on the same model the demo used. This is the "free limit reached"
 * redirect — NOT the post-generation claim (see {@link buildClaimUrl}, which targets `/history`
 * with `claim_asset_id`). Kept free of client-only imports so server code can build it too.
 */
export function buildImageVideoUrl({
  model,
  prompt,
  assetId,
}: {
  model?: string | null;
  prompt?: string | null;
  assetId?: string | null;
}): string {
  const url = new URL(appUrls.imageVideo);
  if (model) url.searchParams.set("model", model);
  if (prompt) url.searchParams.set("prompt", prompt);
  if (assetId) url.searchParams.set("asset_id", assetId);
  return url.toString();
}
